import { useEffect, useState } from "react";
import { Alert } from "../../../components/common/Alert";
import TvsLogo from "../../assets/TvsLogo";
import { LoginConstants } from "../../../constants/constants";
import { PhoneNumberOtpLoginComponent } from "../../../components/common/PhoneNumberOtpLoginComponent";
import TVSMUserLogin from "../../../components/common/TVSMUserLogin";
import MobileResponsivePopupModal from "../../../components/MobileResponsivePopupModal";
import DividerIconForLogin from "../../../assets/images/DividerIconForLogin";
 
export interface LoginMethod {
  method: string;
  label: string;
  icon: React.ComponentType<any>;
  appName: string;
  image: string;
}
 
export interface LoginComponentProps {
  loginMethods: LoginMethod[];
  showPopup?: boolean;
  onPopupClose?: () => void;
  errorMessage: any;
  style: any;
  selectedLoginMethod:string,
  setSelectedLoginMethod:any;
}
 
export const MobileResponsiveLoginComponent: React.FC<LoginComponentProps> = ({
  loginMethods,
  showPopup,
  onPopupClose,
  style,
  errorMessage,
  selectedLoginMethod,
  setSelectedLoginMethod
}) => {
  const [alert, setAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
 
  const LoginMethodsArray = [
    "Phone Number and OTP",
    "Employee id and password",
    " Face recognition",
    // "Fingerprint",
  ];
  const selectedLoginMethodContainer =
    "bg-primary flex flex-col items-center py-2 px-6 border rounded-lg ";
  const unSelectedLoginMethodContainer =
    "flex flex-col items-center py-2 px-4 cursor-pointer";
  const selectedLoginMethodTextBox =
    "w-[12vw] MobileResponsivestaffListHeader text-center text-whiteColor pt-1";
  const unSelectedLoginMethodTextBox = "w-[12vw] smallText text-center pt-1";
 
  return (
    <div className={"pb-8"}>
      <div
        className=" h-screen w-screen inline-block align-bottom bg-whiteColor rounded-lg text-left overflow-hidden  transform transition-all sm:my-8 sm:align-middle w-full"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <div>
          {alert ? <Alert alertMsg={alertMsg} setAlert={setAlert} /> : ""}
          <div className="py-[2vh]">
            <div className="flex justify-between px-4">
              {loginMethods[0]?.image ? (
                <img
                  src={loginMethods[0]?.image ?? ""}
                  alt=""
                  style={{ height: "16px" }}
                />
              ) : (
                <TvsLogo />
              )}
              <div className="text-primary appName">
                {loginMethods[0]?.appName ?? ""}
              </div>
            </div>
            <div className="flex justify-center pt-4  md:my-[2vh]">
              <DividerIconForLogin />
            </div>
            <div className="flex justify-center  items-center mobileResponsiveLoginHeader pt-[2vh] font-poppins">
              {LoginConstants.Login}
            </div>
          </div>
          <PhoneNumberOtpLoginComponent
            selectedLoginMethod={selectedLoginMethod}
            loginMethods={loginMethods}
            buttonPadding={{ padding1: "px-28", padding2: "px-36" }}
          />
          <div className="pt-8">
            {loginMethods.length > 1 && (
              <div className="bg-sideMenubackground flex justify-between px-[5vw] py-[1vh]">
                {loginMethods.map((data: any, index) => {
                  const Icon = data.icon;
                  const color =
                    selectedLoginMethod === data.method ? "white" : "#404040";
                  return (
                    <div
                      key={data.method}
                      className={
                        selectedLoginMethod === data.method
                          ? selectedLoginMethodContainer
                          : unSelectedLoginMethodContainer
                      }
                      onClick={() => {
                        setSelectedLoginMethod(data.method);
                      }}
                    >
                      {Icon && <Icon color={color} />}
                      <div
                        className={
                          selectedLoginMethod === data.method
                            ? selectedLoginMethodTextBox
                            : unSelectedLoginMethodTextBox
                        }
                      >
                        {data.label}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
 
          {/* <TVSMUserLogin
            textStyle="px-2 smallText py-[2vh]  whitespace-nowrap"
            buttonPadding="px-24 py-3"
          /> */}
        </div>
        {showPopup && (
          <MobileResponsivePopupModal
            onClose={onPopupClose || (() => {})}
            content={errorMessage}
            style={style}
          />
        )}
      </div>
    </div>
  );
};
 